import { decryptText, storeTokens } from "../utility/Common";
import { showErrorToastMsg } from "../utility/ToastMessage";
import axios from "axios";

const api = axios.create({
  baseURL: "https://api.royalecon.lk/api/",
  // baseURL: "https://uatlms-001-site1.jtempurl.com/api/",
});

let logoutFunction = null;
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

export const setLogoutHandler = (logoutFn) => {
  logoutFunction = logoutFn;
};

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status !== 401) {
      showErrorToastMsg("Something went wrong.");
      return Promise.reject(error);
    }

    const refreshToken = decryptText(localStorage.getItem("refreshToken"));
    const accessToken = localStorage.getItem("token");

    if (!refreshToken) {
      showErrorToastMsg("Session expired. Please log in again.");
      if (logoutFunction) logoutFunction();
      return Promise.reject(error);
    }

    if (originalRequest.url === "user/refresh-token") {
      showErrorToastMsg("Session expired. Please log in again.");
      if (logoutFunction) logoutFunction();
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return api(originalRequest);
        })
        .catch((err) => Promise.reject(err));
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      const { data } = await axios.post(
        `${api.defaults.baseURL}user/refresh-token`,
        { refreshToken, accessToken },
        { headers: { "Content-Type": "application/json" } },
      );

      if (data && data.Data) {
        const newToken = data.Data?.AccessToken;
        const newRefreshToken = data.Data?.RefreshToken;

        if (newToken) {
          storeTokens(newToken, newRefreshToken);
          processQueue(null, newToken);
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);
        }
      }

      throw new Error("No token in refresh response");
    } catch (refreshError) {
      processQueue(refreshError, null);
      showErrorToastMsg("Session expired. Please log in again.");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      if (logoutFunction) logoutFunction();
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  },
);

export default api;
